export function packageNameFromSpec(spec: string): string {
  if (spec.startsWith('@')) {
    const versionSeparator = spec.indexOf('@', 1)
    return versionSeparator === -1 ? spec : spec.slice(0, versionSeparator)
  }

  const versionSeparator = spec.indexOf('@')
  return versionSeparator === -1 ? spec : spec.slice(0, versionSeparator)
}
